<template>
    <!--<span class="back" @click="gobackClick" title="返回"></span>-->
    <el-button type="primary" class="back" @click="gobackClick"></el-button>
</template>
<style lang="scss" scoped>
  .back{
      display: block;
      width: 100%;
      font-size: 14px;
      font-weight: 700;
      height: 100%;
      position: relative;
      cursor: pointer;
      padding: 2px 4px;
    &:after{
      position:absolute;
      content:'';
      left:50%;
      top:50%;
      margin-left:-3px;
      margin-top:-6px;
      width:8px;
      height:8px;
      transform:rotate(-45deg);
      border-left:3px solid #fff;
      border-top:3px solid #fff;
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/back/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/back/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/back/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-back')
  export default {
    name: 'base-back', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-back': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>